import { useEffect, useReducer } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material"
import { endsWith, startsWith } from "lodash"
import { SORT_DIRECTION } from "helpers/shapes"
import { ASC, DESC } from "helpers/sorts"
import "./style.scss"

function reducer(state, action) {
  if (action.type === "SET_SORT") {
    return computeSort(action.props)
  }
  return state
}

function computeSort({ direction, absolute, order }) {
  if (order) {
    return {
      direction: startsWith(order, ASC) ? ASC : DESC,
      absolute: endsWith(order, "Abs"),
    }
  }
  return {
    direction,
    absolute,
  }
}

export default function SortIcon(props) {
  const [sort, dispatch] = useReducer(reducer, props, computeSort)

  useEffect(() => {
    dispatch({
      type: "SET_SORT",
      props,
    })
  }, [props])

  return (
    <span className={classNames("components_sort-icon", { absolute: sort.absolute })}>
      {sort.direction === ASC ? <ArrowDropUp /> : <ArrowDropDown />}
    </span>
  )
}

SortIcon.propTypes = {
  direction: SORT_DIRECTION,
  absolute: PropTypes.bool,
  order: PropTypes.string,
}
